import { render, staticRenderFns } from "./knowledge-base.vue?vue&type=template&id=1d8b0344&scoped=true"
import script from "./knowledge-base.vue?vue&type=script&lang=js"
export * from "./knowledge-base.vue?vue&type=script&lang=js"
import style0 from "./knowledge-base.vue?vue&type=style&index=0&id=1d8b0344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b0344",
  null
  
)

export default component.exports